import * as Constants from '../../constants';

import { useEffect, useState } from 'react';

import { Button } from "react-bootstrap";

import { faTrash, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import UserFormModal from '../../components/admin/users/UserFormModal.jsx';
import UsersDashboardCards from '../../components/admin/users/UsersDashboardCards.jsx';
import UsersTable from '../../components/admin/users/UsersTable.jsx';
import ConfirmationModal from '../../components/widget/ConfirmationModal.jsx';
import Loading from '../../components/widget/Loading.js';

function UsersPage() {
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [users, setUsers] = useState([]);
    const [userTypes, setUserTypes] = useState([]);
    const [statusTypes, setStatusTypes] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const handleEdit = (user) => {
        setSelectedUser(user);
        setShowModal(true);
    }

    const handleDelete = (user) => {
        setSelectedUser(user)
        setShowDeleteModal(true)
    }

    const handleDeleteConfirmation = (id) => {
        setShowDeleteModal(false)
        setIsLoading(true);

        const controller = new AbortController();
        const signal = controller.signal;
        const token = localStorage.getItem("token");

        fetch(Constants.USERS_DELETE, {
            method: 'DELETE',
            signal: signal,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ id: id }),
        })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(err => { throw err; });
                }
                return response.json();
            })
            .then(responseJson => {
                if (responseJson.status === "success") {
                    setUsers(prevUsers => prevUsers.filter(user => user.id !== id));
                } else {
                    console.error('Erro na API:', responseJson.message);
                }
                setSelectedUser(null);
                setIsLoading(false);
            })
            .catch(error => {
                if (error.name === 'AbortError') return;

                console.error('Erro na requisição de remoção:', error.message || error);
                setIsLoading(false);
            });
    }

    const handleCreate = () => {
        setSelectedUser(null);
        setShowModal(true)
    }

    const handleSave = (user) => {
        setIsLoading(true);

        let url = Constants.USERS_CREATE
        let method = 'POST'
        if (user.id) {
            url = Constants.USERS_UPDATE
            method = 'PUT'
        }
        const controller = new AbortController();
        const signal = controller.signal;

        const token = localStorage.getItem("token");

        fetch(url, {
            method: method,
            signal: signal,
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(user),
        })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(err => { throw err; });
                }
                return response.json();
            })
            .then(responseJson => {
                if (responseJson.status === "success") {
                    const savedUser = responseJson.data; // O usuário que veio do banco
                    console.warn(savedUser);
                    if (user.id) {
                        // Se for EDIÇÃO: substitui o usuário antigo pelo novo no array
                        setUsers(prev => prev.map(u => u.id === savedUser.id ? savedUser : u));
                    } else {
                        // Se for CRIAÇÃO: adiciona o novo usuário ao final (ou início) da lista
                        setUsers(prev => [...prev, savedUser]);
                    }

                    // Se preferir recarregar tudo do zero, chame sua função de fetch inicial:
                    // fetchAllUsers(); 
                }
                setIsLoading(false);
            })
            .catch(error => {
                if (error.name === 'AbortError') {
                    return;
                }
                console.error('Erro na requisição:', error.message || error);
                setIsLoading(false);
            });
    };

    useEffect(() => {

        const controller = new AbortController();
        const signal = controller.signal;

        const fetchData = async () => {

            try {

                setIsLoading(true);

                const token = localStorage.getItem("token");

                const headers = {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                };

                const [usersRes, userTypesRes, statusTypesRes] = await Promise.all([
                    fetch(Constants.USERS_LIST, { method: 'GET', signal, headers }),
                    fetch(Constants.USER_TYPES_LIST, { method: 'GET', signal, headers }),
                    fetch(Constants.USER_STATUS_LIST, { method: 'GET', signal, headers })
                ]);

                if (!usersRes.ok) {
                    const err = await usersRes.json();
                    throw err;
                }

                if (!userTypesRes.ok) {
                    const err = await userTypesRes.json();
                    throw err;
                }

                if (!statusTypesRes.ok) {
                    const err = await statusTypesRes.json();
                    throw err;
                }

                const usersJson = await usersRes.json();
                const userTypesJson = await userTypesRes.json();
                const statusTypesJson = await statusTypesRes.json();

                if (usersJson.status === "success") {
                    setUsers(usersJson.data);
                }

                if (userTypesJson.status === "success") {
                    setUserTypes(userTypesJson.data);
                }

                if (statusTypesJson.status === "success") {
                    setStatusTypes(statusTypesJson.data);
                }
            } catch (error) {

                if (error.name !== 'AbortError') {
                    console.error(error);
                }
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();

        return () => controller.abort();
    }, []);

    return <>
        <div className="container">
            {!isLoading &&
                <>
                    <div className="d-flex justify-content-between mb-4">

                        <h3 style={{ color: '#fff' }}>Gerenciamento de Usuários</h3>

                        <Button onClick={handleCreate}>
                            <FontAwesomeIcon icon={faUserPlus} /> Novo Usuário
                        </Button>

                    </div>
                    <UsersDashboardCards />
                    <UsersTable
                        users={users}
                        userTypes={userTypes}
                        statusTypes={statusTypes}
                        onEdit={handleEdit}
                        onDelete={handleDelete}
                    />
                    <UserFormModal show={showModal} onHide={() => setShowModal(false)} onSave={handleSave} user={selectedUser} />
                </>
            }
            {isLoading && <>
                <Loading />
            </>}

            {showDeleteModal && <ConfirmationModal
                show={showDeleteModal}
                onHide={() => setShowDeleteModal(false)}
                onConfirm={handleDeleteConfirmation}
                title="Remover Usuário"
                message={<p>Tem certeza que deseja excluir o usuário<br /><strong>{selectedUser?.name}</strong>?</p>}
                confirmText="Excluir Agora"
                confirmVariant="danger"
                icon={faTrash}
                isLoading={isLoading}
                id={selectedUser.id}
            />
            }
        </div>
    </>
}

export default UsersPage;